import { Component, OnInit, Input, ElementRef, ViewChild } from '@angular/core'
import { UserProfilePasswordReset } from '../../models/user-profile-password-reset'
import { UserProfile } from '../../models/user-profile'
import { CurrentUser } from '../../../common/models/current-user'
import { UserProfileGateway } from '../../gateways/user-profile-gateway'
import { Router, ActivatedRoute } from '@angular/router'
import { SecurityQuestion } from '../../models/security-question-model'
import { Location } from '@angular/common'
import { UserDataService } from '../../gateways/user-data-service'
import { FormValidationService } from '../../../validations/form-validation-service'
import { UserAccessGateway } from '../../../common/gateways/user-access-gateway'
import { ValidatedSelectOptionModel } from '../../../validations/validated-dropdown.component'
import { NotBlankGenericFieldValidator } from '../../../validations/not-blank-generic-field-validator'
import { PasswordCorrectValidator } from '../../../validations/password-correct-validator'
import { PasswordCorrectCountValidator } from '../../../validations/password-correct-count.component'
import { CurrentUserGateway } from '../../../common/gateways/current-user-gateway'
import { PortalGlobals } from '../../../portalglobals'

@Component({
    selector: 'PasswordReset',
    templateUrl: 'update-password.component.html'
})
export class UpdatePasswordComponent implements OnInit {
    oldPasswordErrorMsg: string
    errorConfMsg: string
    userProfileID: number
    userProfileName: string
    userPassword: string
    CloseBtnText: string
    userProfileModel: UserProfile
    isOldPasswordCorrect: boolean
    passwordResetModel: UserProfilePasswordReset
    securityQuestionModel: SecurityQuestion
    securityQuestion = 0
    securityAnswer = ''
    securityQuestionOld = 0
    securityAnswerOld = ''
    @Input() securityQuestions: SecurityQuestion[]
    navigateTo: string
    isPasswordChange: number
    isChangeEmail: number
    isChangeCellPhoneNumber: number
    selectUndefinedOptionValue: any
    type: string = 'password'
    ErrorMessages: any[]
    errorlist: any[]
    errorlists: any[]
    isFormValid: boolean
    insCo: string
    showSuccessMsg: boolean
    questionOptions: ValidatedSelectOptionModel[] = []
    notBlankValidator = new NotBlankGenericFieldValidator()
    passwordCorrectValidator: PasswordCorrectValidator
    passwordCorrectCountValidator: PasswordCorrectCountValidator
    currentUser: CurrentUser
    @ViewChild('focusableEleTop', { static: true }) focusableEleTop: ElementRef

    constructor(
        private routers: Router,
        private route: ActivatedRoute,
        private _networkUserAccessGateway: UserAccessGateway,
        private currentUserGateway: CurrentUserGateway,
        private userProfileGateway: UserProfileGateway,
        private _location: Location,
        private portalglobals: PortalGlobals,
        private formValidationService: FormValidationService,
        private userdataservice: UserDataService
    ) {
        this.passwordResetModel = {} as UserProfilePasswordReset
        this.securityQuestionModel = {} as SecurityQuestion
        this.userProfileModel = {} as UserProfile
        this.securityQuestions = [] as SecurityQuestion[]
        this.route.params.subscribe((params) => {
            if (params['userprofileid']) {
                this.userProfileID = params['userprofileid']
                this.currentUserGateway.getCurrentUser().subscribe((model: CurrentUser) => {
                    this.currentUser = model
                    this.passwordCorrectValidator = new PasswordCorrectValidator(this.userProfileGateway, this.userProfileID)
                    this.passwordCorrectCountValidator = new PasswordCorrectCountValidator(
                        this.userProfileGateway,
                        this.userProfileID,
                        this.currentUser.userProfileName,
                        this.currentUser.FailedAttemptsLogin
                    )
                    this.isPasswordChange = Number(params['ispasswordchange'])
                    this.isChangeEmail = Number(params['isChangeEmail'])
                    this.isChangeCellPhoneNumber = Number(params['isChangeCellPhoneNumber'])
                    if (this.isPasswordChange === 1) {
                        this.navigateTo = '/' + this.currentUser.insuranceCompanyShortName.toLowerCase() + '/home'
                        this.CloseBtnText = 'Cancel'
                    } else {
                        this.navigateTo = '/' + this.currentUser.insuranceCompanyShortName.toLowerCase() + '/home'
                        this.CloseBtnText = 'Close'
                    }
                })
            }
            if (params['insCo']) {
                this.insCo = params['insCo']
            }
        })
    }
    ngOnInit() {
        this.showSuccessMsg = false
        this.isFormValid = true
        this.userProfileGateway.findUserProfileByProfileID(this.userProfileID).subscribe((model: UserProfile) => {
            if (model !== undefined && model !== null) {
                this.userProfileModel = model
                this.passwordResetModel = new Object() as UserProfilePasswordReset
                this.passwordResetModel.UserProfileName = this.userProfileModel.UserProfileName
                this.passwordResetModel.newPassword = ''
                this.passwordResetModel.confirmPassword = ''
                this.userProfileName = this.passwordResetModel.UserProfileName
            }
        })

        this.userProfileGateway.getSecurityQuestion(this.userProfileID).subscribe((model: SecurityQuestion) => {
            if (model !== undefined && model !== null) {
                this.securityQuestionModel = model
                this.securityQuestion =
                    this.securityQuestionModel.QuestionID !== 0 || this.securityQuestionModel.QuestionID !== undefined
                        ? this.securityQuestionModel.QuestionID
                        : 1
                this.securityAnswer = this.securityQuestionModel.SecurityAnswer !== undefined ? this.securityQuestionModel.SecurityAnswer : ''
            }
        })
        this.userProfileGateway.getSecurityQuestions().subscribe((questions: SecurityQuestion[]) => {
            this.securityQuestions = questions
            console.log('SecurityQuestions' + this.securityQuestions)
            var i
            for (i = 0; i < this.securityQuestions.length; i++)
                this.questionOptions.push({
                    value: this.securityQuestions[i].QuestionID,
                    text: this.securityQuestions[i].Question
                })
            this.questionOptions.unshift({ value: 0, text: '-- Choose One --' })
            this.securityQuestion = 0
        })
    }

    //onBlurForOldPassword(password: string) {
    //    this.userProfileGateway.isPasswordCorrect(encodeURIComponent(password), this.userProfileID).subscribe(
    //        (model: boolean) => {
    //            if (model.valueOf() === true) {
    //                this.isOldPasswordCorrect = true
    //            } else {
    //                this.oldPasswordErrorMsg = 'The password you entered is incorrect'
    //                this.isOldPasswordCorrect = false
    //            }
    //        })
    //}

    onQuestionChange(value: number) {
        this.securityQuestion = value
    }

    private validateForm() {
        this.ErrorMessages = []
        this.isFormValid = true
        if (this.securityAnswer !== undefined || this.securityAnswer !== null || this.securityAnswer !== '') {
            if (this.securityAnswer === this.userProfileName) {
                this.isFormValid = false
                this.ErrorMessages.push('Security Answer cannot be same as LoginID')
            }
        }
        if (this.securityQuestion === 0 || this.securityQuestion.toString() === '0') {
            this.isFormValid = false
            this.ErrorMessages.push('Please Select Security Question')
        }
        if (this.securityAnswer === undefined || this.securityAnswer === null || this.securityAnswer === '') {
            this.isFormValid = false
            this.ErrorMessages.push('Please enter Security Answer')
        }

        if (this.securityAnswer !== undefined || this.securityAnswer !== null || this.securityAnswer !== '') {
            if (this.securityAnswer === this.passwordResetModel.newPassword) {
                this.isFormValid = false
                this.ErrorMessages.push('Security Answer cannot be same as Password')
            }
        }
    }

    Save() {
        this.formValidationService.validateAll(
            () => {
                this.validateForm()
                if (this.isFormValid === true) {
                    if (this.securityAnswer === undefined || this.securityAnswer === null || this.securityAnswer === '') {
                        this.securityAnswer = ' '
                    }
                    this.userProfileGateway
                        .updateUserChangePasswordAndSecurityChallenge(
                            encodeURIComponent(this.passwordResetModel.newPassword),
                            this.securityQuestion,
                            this.securityAnswer,
                            this.userProfileID
                        )
                        .subscribe(
                            (model: Boolean) => {
                                if (model.valueOf() === true) {
                                    this.isFormValid = true
                                    this.showSuccessMsg = true
                                    this.errorConfMsg = 'You have successfully changed the password.'
                                    this.passwordResetModel.newPassword = ''
                                    this.passwordResetModel.confirmPassword = ''
                                    this.userPassword = ''
                                    this.isPasswordChange = 1
                                    if (this.isPasswordChange === 1) {
                                        // let url = '/user-management/licenselogin/' + this.userProfileID
                                        // this.routers.navigateByUrl(url)
                                        this.redirectnextPage()
                                    } else {
                                        this._location.back()
                                    }
                                } else {
                                    this.showSuccessMsg = false
                                    this.isFormValid = false
                                    this.ErrorMessages = ['Something went wrong, please try again.']
                                }
                                this.focusableEleTop.nativeElement.focus()
                            },
                            (error) => {
                                this.showSuccessMsg = false
                                this.ErrorMessages = this.extractErrorMessages(error)
                                this.isFormValid = false
                                this.focusableEleTop.nativeElement.focus()
                            }
                        )
                } else {
                    this.focusableEleTop.nativeElement.focus()
                }
            },
            () => {}
        )
    }

    private extractErrorMessages(error: any): string[] {
        const previousPasswordMessage = 'You cannot use a previous password'

        const mapToDisplayMessages = (messages: string[]): string[] => {
            const normalized = messages.map((m) => String(m || ''))
            const hasPreviousPasswordError = normalized.some((m) =>
                m.toLowerCase().indexOf(previousPasswordMessage.toLowerCase()) >= 0
            )

            if (hasPreviousPasswordError) {
                return [previousPasswordMessage]
            }

            return normalized
        }

        if (error && error.error) {
            if (Array.isArray(error.error)) {
                return mapToDisplayMessages(error.error)
            }

            if (typeof error.error === 'string') {
                try {
                    const parsed = JSON.parse(error.error)
                    if (Array.isArray(parsed)) {
                        return mapToDisplayMessages(parsed)
                    }
                } catch {
                    if (error.error.length > 0) {
                        if (error.error.toLowerCase().indexOf(previousPasswordMessage.toLowerCase()) >= 0) {
                            return [previousPasswordMessage]
                        }
                        return [error.error]
                    }
                }
            }
        }

        if (error && typeof error.statusText === 'string' && error.statusText.length > 0) {
            try {
                const parsedStatus = JSON.parse(error.statusText)
                if (Array.isArray(parsedStatus)) {
                    return mapToDisplayMessages(parsedStatus)
                }
            } catch {
                if (error.statusText.toLowerCase().indexOf(previousPasswordMessage.toLowerCase()) >= 0) {
                    return [previousPasswordMessage]
                }
                if (error.statusText !== 'Unknown Error') {
                    return [error.statusText]
                }
            }
        }

        return ['Something went wrong, please try again.']
    }

    cancel() {
        if (this.isPasswordChange === 1) {
            sessionStorage.clear()
            localStorage.clear()
            window.location.href = '/Auth/Logout.aspx'
        } else {
            this._location.back()
        }
    }
    private redirectnextPage() {
        this._networkUserAccessGateway.getCurrentUser().subscribe(
            (user) => {
                if (user != null) {
                    console.log('user AGAUTH: ' + user.BgAuthorized)
                    const insCompany = user.insuranceCompanyShortName.toLowerCase()
                    if (this.isChangeEmail == 1) {
                        let url = '/' + insCompany + '/user-management/ChangeEmail/' + user.userProfileId + '/' + this.isChangeCellPhoneNumber //+ '/' + insCompany
                        this.routers.navigateByUrl(url)
                    } else if (this.isChangeCellPhoneNumber == 1) {
                        let url = '/' + insCompany + '/user-management/ChangeCellPhoneNo/' + user.userProfileId //+ '/' + insCompany
                        this.routers.navigateByUrl(url)
                    }  else if (localStorage.getItem('showlicense') === null || localStorage.getItem('showlicense') === 'null') {
                        let url = '/' + insCompany + '/user-management/licenselogin/' + user.userProfileId //+ '/' + insCompany
                        this.routers.navigateByUrl(url)
                    } else {
                        this.routers.navigate(['/' + insCompany + '/home'])
                    }
                } else {
                    this.goToLogin()
                }
            },
            (error) => {
                this.goToLogin()
            }
        )
    }
    goToLogin() {
        window.location.href = '/Auth/Login.aspx?insCo=' + this.insCo
    }
}
